import React from 'react';

const TableHead = () => (
    <thead className="thead-light">
        <tr>
        <th scope="col">Data</th>
        <th scope="col">Código de Barras</th>
        <th scope="col">Valor</th>
        <th scope="col">Data de Vencimento</th>
        <th scope="col">Status</th>
        <th scope="col">Data de Liquidação</th>
        {/* <th scope="col">Banco</th> */}
        {/* <th scope="col"></th> */}
        </tr>
    </thead>
);

export default TableHead;


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Bills/TableHead.js